import { Component, Vue, Watch } from 'vue-property-decorator';

import template from './set-password.vue';
import apiService from '@/services/api.service';

@Component({
  mixins: [template],
})
export default class SetPassword extends Vue {
  title: string = this.$package.title;
  password: string = '';
  passwordRepeat: string = '';
  passwordsError: string = '';
  generalError: string = '';

  @Watch('password')
  @Watch('passwordRepeat')
  updatePasswordError() {
    if ((this.passwordsError === 'short_password' && this.password.length >= 5) || this.passwordsError === 'unequal_passwords') {
      this.passwordsError = '';
    }
  }

  created() {
    document.addEventListener('keypress', this.onEnterPress);
  }

  beforeDestroy() {
    document.removeEventListener('keypress', this.onEnterPress);
  }

  onEnterPress(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.code === 'Enter' || event.charCode === 13) {
      this.sendForm();
    }
  }

  resetForm() {
    this.password = '';
    this.passwordRepeat = '';
  }

  async sendForm() {
    if (!(
      this.password.match(/[a-z]/g) &&
      this.password.match(/[A-Z]/g) &&
      this.password.match(/[0-9]/g) &&
      this.password.match(/[^a-zA-Z\d]/g) &&
      this.password.length >= 8
    )) {
      this.passwordsError = 'short_password';
    } else if (this.password !== this.passwordRepeat) {
      this.passwordsError = 'unequal_passwords';
    } else {
      try {
        const result = await apiService.activateUser({ token: this.$route.params.token, password: this.password });
        if (result) {
          this.$router.push({ path: '/login' });
        }
      } catch (e) {
        this.generalError = 'invalid_token';
      }
    }
  }
}